import tooltipHOC from "../../../../../../components/tooltipHOC";


export default function NodeMenuItem({name}) {
    return <p className="project-dfd-menu-item">{name}</p>;
}

export const HintedNodeMenuItem = tooltipHOC(NodeMenuItem, undefined, {direction: "bottom", padding: "10px"});